import { R } from '@/features/profile/resources/ProfileResources.resx';
import { ProfilePaths } from '@/features/profile/model/types';

export const profileMenuItems = [
    { path: ProfilePaths.MyInformation, title: R.MyInformation },
    { path: ProfilePaths.Access, title: R.Access },
    { path: ProfilePaths.Household, title: R.Household },
    { path: ProfilePaths.Pets, title: R.Pets },
    { path: ProfilePaths.Language, title: R.Language },
    { path: ProfilePaths.Newsletter, title: R.Newsletter },
    { path: ProfilePaths.OnlinePharmacy, title: R.OnlinePharmacy },
    { path: ProfilePaths.DeleteAccount, title: R.DeleteAccount },
];

export const accessSubPaths = [
    ProfilePaths.InsurancePartnerDetails,
    ProfilePaths.SelectInsurancePartner,
    ProfilePaths.CouponDetails,
    ProfilePaths.TrainingProgramDetails,
    ProfilePaths.SubscriptionDetails,
];
